import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { CircularProgress, NavPills } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import useProjectInstallationData from 'modules/project-installation/hooks/useProjectInstallationData';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import React from 'react';

const ProjectInstallationLayout = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { hasPermission } = useAuthPermission();

    const { projectInstallation, isLoading } = useProjectInstallationData(
        clientInstallationId!,
        projectInstallationId!
    );

    const navItems = [
        {
            content: 'Projects Details',
            href: `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/details`,
            isActive:
                pathname.startsWith(
                    `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/details`
                ) ||
                pathname.startsWith(
                    `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/edit`
                ),
            permission: hasPermission(PermissionEnum.PROJECT_INSTALLATION_UPDATE),
        },
        {
            content: 'Recce',
            href: `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/recce`,
            isActive: pathname.startsWith(
                `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/recce`
            ),
            permission: hasPermission(PermissionEnum.PROJECT_INSTALLATION_UPDATE),
        },
        {
            content: 'Purchase Orders',
            href: `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order`,
            isActive: pathname.startsWith(
                `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order`
            ),
            permission: hasPermission(PermissionEnum.PROJECT_INSTALLATION_UPDATE),
        },
    ];

    const visibleNav = navItems.filter((n) => n.permission);

    return (
        <div>
            <div className="px-5">
                {/* Header: stacks on mobile, inline on sm+ */}
                <div className="mt-4  gap-2 sm:flex-row sm:items-center sm:gap-4">
                    <div className="flex items-center gap-3">
                        <BackButton to={`/client-installations/${clientInstallationId}/project-installations`} />
                        <div className="text-base font-semibold">
                            {isLoading ? <CircularProgress size={16} /> : projectInstallation?.name}
                        </div>
                    </div>

                    {/* Pills row: full-width scroll on mobile */}
                    <div className="sm:ml-auto w-full sm:w-auto mt-4">
                        {/* Negative margin to let the scroll edge reach screen sides, with matching padding */}
                        <div className="-mx-5 sm:mx-0">
                            <div
                                className="overflow-x-auto px-5 sm:px-0 no-scrollbar"
                                aria-label="Project installation navigation"
                            >
                                <NavPills
                                    className="min-w-max"
                                    items={visibleNav.map((item) => ({
                                        content: <Link to={item.href}>{item.content}</Link>,
                                        isActive: item.isActive,
                                        onClick: () => navigate(item.href),
                                    }))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Outlet />
        </div>
    );
};

export default ProjectInstallationLayout;
